import { useEffect, useState } from "react";

interface InstallPrompt extends Event {
  prompt: () => Promise<void>;
}
const KEY = "learn-install-dismissed";

function dismissed() {
  try {
    return localStorage.getItem(KEY) === "1";
  } catch {
    return false;
  }
}

/** Alerts on iPhone only work from the installed app, so say how to install it there. Other
 *  browsers offer a real install prompt. Hidden once installed or dismissed. */
export function InstallBanner() {
  const [prompt, setPrompt] = useState<InstallPrompt | null>(null);
  const [hidden, setHidden] = useState(dismissed());
  const standalone =
    window.matchMedia("(display-mode: standalone)").matches ||
    (navigator as Navigator & { standalone?: boolean }).standalone === true;
  const ios = /iPhone|iPad|iPod/.test(navigator.userAgent);

  useEffect(() => {
    const onPrompt = (e: Event) => {
      e.preventDefault();
      setPrompt(e as InstallPrompt);
    };
    window.addEventListener("beforeinstallprompt", onPrompt);
    return () => window.removeEventListener("beforeinstallprompt", onPrompt);
  }, []);

  if (standalone || hidden || (!ios && !prompt)) return null;
  const dismiss = () => {
    try {
      localStorage.setItem(KEY, "1");
    } catch {
      /* private mode: it just comes back next time */
    }
    setHidden(true);
  };
  return (
    <div className="banner">
      <b>{ios ? "Get alerts on your iPhone" : "Install Learn"}</b>
      <p>
        {ios
          ? "Tap Share, then “Add to Home Screen”. Alerts only work from the installed app."
          : "Add it to your home screen for quick access and alerts."}
      </p>
      <div className="row">
        {prompt && (
          <button type="button" className="btn small" onClick={() => void prompt.prompt()}>
            Install
          </button>
        )}
        <button type="button" className="btn small ghost" onClick={dismiss}>
          Not now
        </button>
      </div>
    </div>
  );
}
